import React, { Component } from 'react';
import { appendAttachment } from '../../../utils/FormDataUtils';
import '../../../resources/AdminStandardPage.css';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { financialSituationService } from '../../../services/FinancialSituationService';
import ReactPaginate from 'react-paginate';

class AdminFinancialSituation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledDocument: false,
      newFinancialSituation: {
        title: '',
        document: '',
        date: ''
      },
      existingFinancialSituations: [],
      deleteFinancialSituation: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };

    this.authentication = new AuthenticationService();
  }

  componentWillMount() {
    financialSituationService
      .getAll()
      .then(jsonResponse => {
        this.setFinanctialSituationState(jsonResponse);
      })
      .catch(error => console.log(error));
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  handlePageClick = selectedPage => {
    financialSituationService
      .getAll(selectedPage.selected + 1)
      .then(jsonResponse => {
        this.setFinanctialSituationState(jsonResponse);
      })
      .catch(error => console.log(error));
  };

  setFinanctialSituationState = response => {
    let existingFinancialSituations = {
      ...this.state.existingFinancialSituations
    };
    let pagination = { ...this.state.pagination };
    existingFinancialSituations = response.financial_situations;
    pagination = response.pagination;

    this.setState({ existingFinancialSituations });
    this.setState({ pagination });
  };

  updateField = event => {
    const field = event.target.name;
    const newFinancialSituation = this.state.newFinancialSituation;
    newFinancialSituation[field] = event.target.value;

    this.setState({
      newFinancialSituation
    });
  };

  onDropDocument = documents => {
    let newFinancialSituation = { ...this.state.newFinancialSituation };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newFinancialSituation.document = documents[0];

      self.setState({ newFinancialSituation });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newFinancialSituation = { ...this.state.newFinancialSituation };
    newFinancialSituation.document = null;

    this.setState({ newFinancialSituation });
    this.setState({ disabledDocument: false });
  };

  resetForm = () => {
    let newFinancialSituation = { ...this.state.newFinancialSituation };
    newFinancialSituation = {
      title: '',
      document: ''
    };

    this.setState({ newFinancialSituation });
    this.setState({ disabledDocument: false });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    const currentId = this.state.newFinancialSituation.id;

    const headers = {
      Accept: 'application/json'
    };

    if (this.authentication.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.authentication.getToken();
    }

    let url = `${process.env.REACT_APP_API_URL}/api/financial_situations/`;
    let callMethod = 'POST';

    if (currentId) {
      url = `${process.env.REACT_APP_API_URL}/api/financial_situations/${this.state.newFinancialSituation.id}`;
      callMethod = 'PUT';
    }

    const formattedData = this.buildFormData();

    fetch(url, {
      method: callMethod,
      body: formattedData,
      headers
    })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(jsonResponse => {
        this.resetForm();

        let existingFinancialSituations = this.state.existingFinancialSituations.slice();

        let index = existingFinancialSituations.findIndex(
          existingFinancialSituation =>
            existingFinancialSituation.id === jsonResponse.id
        );

        if (index !== -1) {
          existingFinancialSituations[index] = jsonResponse;
        } else {
          existingFinancialSituations.push(jsonResponse);
        }

        this.setState({ existingFinancialSituations });

        if (currentId) {
          this._notificationSystem.addNotification({
            message: 'Situatia a fost editata cu success.',
            level: 'success',
            position: 'tc'
          });
        } else {
          this._notificationSystem.addNotification({
            message: 'Situatia a fost adaugata cu success.',
            level: 'success',
            position: 'tc'
          });
        }
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  buildFormData() {
    let formData = new FormData();
    formData.append(
      'financial_situation[title]',
      this.state.newFinancialSituation.title
    );
    formData.append(
      'financial_situation[add_date]',
      this.state.newFinancialSituation.date
    );

    if (this.state.newFinancialSituation.document) {
      let document = this.state.newFinancialSituation.document;
      appendAttachment(formData, `financial_situation[document]`, document);
    }

    return formData;
  }

  setConvocationAgendaForEdit = newFinancialSituationDoc => {
    let newFinancialSituation = { ...this.state.newFinancialSituation };
    newFinancialSituation = Object.assign({}, newFinancialSituationDoc);
    this.setState({ newFinancialSituation });

    if (newFinancialSituation.document.url) {
      this.setState({ disabledDocument: true });
    }
  };

  openDeleteDialog = id => {
    let deleteFinancialSituation = { ...this.state.deleteFinancialSituation };
    deleteFinancialSituation = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteFinancialSituation });
  };

  closeDeleteDialog = () => {
    let deleteFinancialSituation = { ...this.state.deleteFinancialSituation };
    deleteFinancialSituation = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteFinancialSituation });
  };

  handleDelete = () => {
    financialSituationService
      .deleteFinancialSituation(this.state.deleteFinancialSituation.deleteId)
      .then(() => {
        let existingFinancialSituations = this.state.existingFinancialSituations.slice();
        existingFinancialSituations = existingFinancialSituations.filter(
          financialSituation =>
            financialSituation.id !==
            this.state.deleteFinancialSituation.deleteId
        );
        this.setState({ existingFinancialSituations });

        this.closeDeleteDialog();

        this._notificationSystem.addNotification({
          message: 'Situatia a fost stearsa cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  handleErrors = response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Financiar
          </h3>
          <h1 className="admin-switch-title default-title">
            Situatie Financiara
          </h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">
                  Adauga o situatie financiara noua
                </h2>

                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu situatie financiara*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newFinancialSituation.title}
                  />
                </div>
                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">Data*</h4>
                  <input
                    required
                    className="general-field title-field"
                    type="date"
                    name="date"
                    onChange={this.updateField}
                    value={this.state.newFinancialSituation.date}
                  />
                </div>
                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document situatie financiara:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newFinancialSituation.document}
                    documentFilename={
                      this.state.newFinancialSituation.document_filename
                    }
                    type="application/pdf"
                  />
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newFinancialSituation.id
                        ? 'Editează situatie financiara'
                        : 'Adaugă situatie financiara'}
                    </button>
                  </div>
                  {Object.values(this.state.newFinancialSituation) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          {this.state.existingFinancialSituations.length > 0 && (
            <div className="admin-standard-page__existing-items">
              <div className="card">
                <div className="existing-items">
                  <h2 className="existing-items__title label-title">
                    Situatii financiare existente
                  </h2>
                  <div className="existing-items__content">
                    {this.state.existingFinancialSituations.map(
                      financialSituation => (
                        <div
                          className="existing-items__content-card"
                          key={financialSituation.id}
                        >
                          <div className="card-content provisions-title-content">
                            <h3 className="major-provisions-title">
                              {financialSituation.title}
                            </h3>
                          </div>
                          <div className="existing-items__actions-card">
                            <div
                              className="provisions-title-content"
                              onClick={() =>
                                this.setConvocationAgendaForEdit(
                                  financialSituation
                                )
                              }
                            >
                              <h4 className="action-title"> Editează</h4>
                            </div>

                            <div
                              className="provisions-title-content"
                              onClick={() =>
                                this.openDeleteDialog(financialSituation.id)
                              }
                            >
                              <h4 className="action-title delete-button">
                                {' '}
                                Șterge
                              </h4>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                  <DeletePUGCertificates
                    opened={this.state.deleteFinancialSituation.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteti sigur ca doriti sa stergeti acest document?"
                    aditionalText="Dupa stergere, documentul nu va mai putea fi recuperat."
                  />
                </div>
                {this.state.pagination.last_page > 1 && (
                  <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pagination.last_page}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}

export default AdminFinancialSituation;
